/* Local draft only. Review before adding to a draft theme or GTM container. */
(function () {
  var viewSent = false;

  function pushEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
  }

  function safeToken(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '') || 'unknown';
  }

  function modulePayload(module) {
    var estimate = module.querySelector('[data-rs-arrive-by="true"]');
    var estimateState = estimate ? safeToken(estimate.getAttribute('data-rs-arrive-by-state') || 'pending') : 'missing';
    return {
      product_handle: module.getAttribute('data-rs-product-handle') || '',
      temperature_bucket: safeToken(module.getAttribute('data-rs-temperature-bucket') || 'unknown'),
      product_type: module.getAttribute('data-rs-product-type') || '',
      conversion_path: safeToken(module.getAttribute('data-rs-conversion-path') || 'cart_checkout'),
      arrive_by_signal_state: 'arrive_by_' + estimateState,
      estimated_arrive_by_bucket: estimate ? safeToken(estimate.getAttribute('data-rs-arrive-by-window') || 'pending') : 'missing',
      experiment_id: module.getAttribute('data-rs-experiment-id') || 'P1-PRODUCT-ARRIVE-BY'
    };
  }

  function currentModule(target) {
    if (target && target.closest) {
      var scoped = target.closest('[data-rs-product-delivery="true"]');
      if (scoped) return scoped;
    }
    return document.querySelector('[data-rs-product-delivery="true"]');
  }

  function pushView() {
    if (viewSent) return;
    var module = currentModule();
    if (!module) return;
    viewSent = true;
    pushEvent('delivery_estimate_view', modulePayload(module));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushView, { once: true });
  } else {
    pushView();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rs-arrive-by-zip-apply]');
    if (!button) return;
    var module = currentModule(button);
    if (!module) return;
    window.setTimeout(function () {
      pushEvent('delivery_estimate_interact', modulePayload(module));
    }, 0);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-rs-arrive-by-zip-input]');
    if (!input) return;
    var module = currentModule(input);
    if (!module) return;
    window.setTimeout(function () {
      pushEvent('delivery_estimate_interact', modulePayload(module));
    }, 0);
  });
}());
